import { internal } from '../vendor/elix.js';
import prefixStyleSelectorsWithTagName from './prefix-style-selectors-with-tag-name.js';

function ScopedStylesForEdgeBrowserMixin(Base) {
  return class ScopedStylesForEdgeBrowser extends Base {

    get [internal.template]() {

      const template = super[internal.template];
      const tagName = this.tagName.toLowerCase()
      const styles = Array.from(template.content.querySelectorAll('style'));

      styles.forEach((style) => {
        style.textContent = prefixStyleSelectorsWithTagName(tagName, style.textContent);
      });

      const templateCopy = document.createElement('template');
      templateCopy.innerHTML = template.innerHTML;
      return templateCopy;
    }

  }
}

export default ScopedStylesForEdgeBrowserMixin;
